import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export class CustomTranslateHttpLoader implements TranslateLoader {

  public static assetPath = '';
  public prefix = '/assets/i18n/';
  public suffix = '.json';

  constructor(private http: HttpClient, prefix?: string, suffix?: string) {
    if (prefix) {
      this.prefix = prefix;
    }
    if (suffix) {
      this.suffix = suffix;
    }
  }

  public getTranslation(lang: string): Observable<any> {
    return this.http.get(`${CustomTranslateHttpLoader.assetPath}/i18n/${lang}${this.suffix}`);
  }

}
